import { render, staticRenderFns } from "./teacherBlock.vue?vue&type=template&id=f9f847aa&scoped=true"
import script from "./teacherBlock.vue?vue&type=script&lang=js"
export * from "./teacherBlock.vue?vue&type=script&lang=js"
import style0 from "../index.css?vue&type=style&index=0&id=f9f847aa&prod&scoped=true&lang=css&external"
import style1 from "./teacherBlock.vue?vue&type=style&index=1&id=f9f847aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f847aa",
  null
  
)

export default component.exports